import SettingOptionSelector from './SettingOptionSelector'
import MultiOptionSelector from './multi-option-selector'
import InstitutionSchoolSelector from './InstitutionSchoolSelector'
import DateToggle from '../date-toggle'
import UserFlags from './user-flags'

export default [
  { name: 'First Name', prop: 'first_name', type: 'text' },
  { name: 'Last Name', prop: 'last_name', type: 'text' },
  { name: 'Name', prop: 'name', type: 'text', disabled: true },
  { name: 'Nickname', prop: 'nickname', type: 'text' },
  { name: 'Picture', prop: 'avatar', type: 'image', url: 'avatar_url' },
  { name: 'Email Address', prop: 'email', type: 'text' },
  { name: 'Phone Number', prop: 'phone_number', type: 'text' },
  { name: 'Confirmed', prop: 'confirmed_at', type: 'component', component: DateToggle },
  { name: 'Password', prop: 'password', type: 'password' },
  { name: 'University', prop: 'university', type: 'text' },
  {
    name: 'Title',
    prop: 'title',
    type: 'component',
    component: SettingOptionSelector,
    componentProps: { settingKey: 'titles', nullable: true }
  },
  {
    name: 'Discipline',
    prop: 'discipline',
    type: 'component',
    component: SettingOptionSelector,
    componentProps: { settingKey: 'disciplines' }
  },
  {
    name: 'Discipline Classifications',
    prop: 'discipline_classification',
    type: 'component',
    component: SettingOptionSelector,
    componentProps: { settingKey: 'discipline_classifications' }
  },
  {
    name: 'Post Nominal Letters',
    prop: 'post_nominal_letters',
    type: 'component',
    component: SettingOptionSelector,
    componentProps: { settingKey: 'post_nominal_letters', nullable: true }
  },
  { name: 'Department', prop: 'department', type: 'text' },
  {
    name: 'School or College',
    prop: 'school_or_college_id',
    type: 'component',
    component: InstitutionSchoolSelector
  },
  { name: 'About me', prop: 'about_me', type: 'textarea' },
  { name: 'Admin', prop: 'roles', type: 'checkbox', isArray: true, item: 'admin' },
  { name: 'Coach', prop: 'roles', type: 'checkbox', isArray: true, item: 'coach' },
  { name: 'Head Coach', prop: 'roles', type: 'checkbox', isArray: true, item: 'head_coach' },
  { name: 'Facilitator', prop: 'roles', type: 'checkbox', isArray: true, item: 'facilitator' },
  { name: 'Include in directory?', prop: 'include_in_listing', type: 'checkbox' },
  { name: 'Post checkin reminders as this user?', prop: 'use_for_checkin_reminders', type: 'checkbox' },
  {
    name: 'Flags',
    prop: 'flags',
    type: 'component',
    component: UserFlags
  },
  { name: 'Chatting Banned Until', prop: 'chatting_banned_until', type: 'date' },
  { name: 'Chatting Banned Reason', prop: 'chatting_banned_reason', type: 'text' },
  { name: 'Commenting Banned Until', prop: 'commenting_banned_until', type: 'date' },
  { name: 'Commenting Banned Reason', prop: 'commenting_banned_reason', type: 'text' },
  {
    name: 'Gender',
    prop: 'gender',
    type: 'component',
    component: MultiOptionSelector,
    componentProps: { settingKey: 'genders' }
  },
  { name: 'Ethnicity', prop: 'ethnicities', type: 'component', component: MultiOptionSelector, componentProps: { settingKey: 'ethnicities' } },
  { name: 'Address line 1', prop: 'address_line_1', type: 'text' },
  { name: 'Address line 2', prop: 'address_line_2', type: 'text' },
  { name: 'City', prop: 'city', type: 'text' },
  { name: 'Postal Code', prop: 'postal_code', type: 'text' },
  {
    name: 'CountryState',
    type: 'country-state',
    stateProp: 'state',
    countryProp: 'country'
  },
  {
    name: 'Internal Notes',
    prop: 'internal_notes',
    type: 'textarea'
  }
]
